module.exports = __webpack_public_path__ + "static/media/key.e3d5f576.svg";